module.exports = __webpack_public_path__ + "media/step-2.fff154ea.mp4";